import { render } from "./EmployerAdditionalInformation.vue?vue&type=template&id=1276f532"
import script from "./EmployerAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./EmployerAdditionalInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__